import { useParams } from 'react-router-dom'
import "../styles/SingleBook.css"
import { useQuery } from '@tanstack/react-query';
import { getBookById, getBooksByCategory } from '../services/booksApi';
import Layout from '../components/Layout';
import StarRating from '../components/StarRating';
import BookLoading from '../components/BookLoading';
import Error from '../components/Error';
import { useState } from 'react';
import ReviewModel from '../components/ReviewModel';
import StarLine from '../components/StarLine';
import ReviewComment from '../components/ReviewComment';
import BookCard from '../components/BookCard';
import NavigationControl from '../components/NavigationControl';
import GetBookSidebar from '../components/GetBookSidebar';
import Notification from '../components/Notification';
import { useCart } from '../context/CartContext';

function SingleBook() {
    const { _id } = useParams();
    const { toast } = useCart();

    const [GetNow, setGetNow] = useState(false);
    const [isOpen, setOpen] = useState(false)


    const { data, isLoading, error } = useQuery({
        queryKey: ["book", _id],
        queryFn: ({ signal }) => getBookById({ _id, signal }),
    });

    const book = data?.data ?? {};
    const hasPurchased = data?.hasPurchased ?? false;
    const category = data?.data?.category;

    // Similar books (same Category)
    const response = useQuery({
        queryKey: ["books", category],
        queryFn: ({ signal }) => getBooksByCategory({ category, signal }),
        enabled: !!category
    });

    const books = response?.data?.data ?? [];

    const getNowButtonHandler = (e) => {
        setGetNow(true)
    }

    if (isLoading) return <BookLoading />
    if (error) return <Error error={error} />

    return (
        <Layout>
            {toast && <Notification message={toast} />}
            <NavigationControl />
            {GetNow && <GetBookSidebar book={book} onClose={setGetNow} />}
            <br />
            <ReviewModel isOpen={isOpen} onClose={(e) => setOpen(false)} id={_id} />

            <div className="singleBookMain">
                {/* <h2 style={{ margin: "0 20px" }}>Book</h2> */}
                <div className="singleBookTop">
                    <span className="Availability" style={{ backgroundColor: book.stock > 0 ? "var(--success-color)" : "var(--error-color)" }}>{book.stock > 0 ? "Available" : "N/A"}</span>
                    <img src={book.coverImage} alt={book.title} />
                    <div className="SBookTopInfo">

                        <h2 className='singleBookTitle' >{book.title}</h2>
                        <div className="SBookAuthor">
                            <p>{book.author}</p>&nbsp;&nbsp;
                            <i className="fa-solid fa-pen"></i>
                        </div>
                        <div className="SBookPrice">
                            <p>₹{book.price}</p>
                        </div>
                        <p className='SBookDescription'>
                            {book.description}
                        </p>
                        {book.stock > 0 && <div className="SBookButtons">
                            <button className='btn' onClick={getNowButtonHandler}>Get&nbsp;Now&nbsp;!!</button>
                        </div>}

                    </div>
                </div>
                <div className="bookInfo">
                    <div className="bookInfoTop">
                        <h2>Details</h2>
                        <div className="productRating"><span style={{ whiteSpace: 'nowrap' }}><b style={{ color: '#555' }}>{book.ratings} </b> * | {book?.reviews?.length} Ratings</span></div>

                    </div>
                    <hr />
                    <p><b>Book : </b>{book.title}</p>
                    <p><b>Author : </b>{book.author}</p>
                    <p><b>Available Stock : </b>{book.stock}</p>
                    <p><b>Price : </b>₹{book.price}</p>
                    <p><b>Language : </b>{book.language}</p>
                    <p><b>Category : </b>{book.category}</p>
                    <p className='genres'>
                        <b>Genres   : </b>
                        {book.genres?.map((curr, i) => {
                            return <span key={i}>{curr}, </span>
                        })}
                    </p>
                    <p style={{ textAlign: 'justify' }} className='SBookDescription'><b>Description : </b>"{book.description}"</p>

                </div>

                <div className="RatingsAndReviews">
                    <div className="reviewAndRatingLeft">
                        <h1>{book.ratings?.toFixed(1)}</h1>
                        <StarRating ratings={book.ratings} />
                        <br />
                        <p>{book.reviews?.length} reviews</p>
                    </div>
                    <div className="reviewAndRatingRight">
                        {book?.reviews &&
                            [5, 4, 3, 2, 1].map((r) => {
                                return <StarLine key={r} number={r} reviews={book?.reviews?.filter(curr => curr.rating === r ?? curr)} totalReviews={book?.reviews?.length} />
                            })
                        }
                        <br />
                        {hasPurchased && <button className='btn' onClick={(e) => setOpen(true)}>Write a Review</button>}
                    </div>

                </div>
                <div className="customerReviews">
                    {book.reviews?.map((curr) => {
                        return (
                            <ReviewComment key={curr._id} review={curr} />
                        )
                    })}
                </div>
            </div>
            <h3 style={{ margin: "0 10px" }}>You might like</h3>
            <br />
            <div className="bookContainer">
                {books.map((book, i) => (
                    <BookCard key={i} book={book} />
                ))}
            </div>

        </Layout>
    )
}

export default SingleBook